module.exports = __webpack_public_path__ + "fonts/Nunito-SemiBold.76ae20d.ttf";